export const inziData=[
    {
        "PatientAssessmentId": "dqukj0e7dctB9IHrlxkVbA==",
        "TreatmentPlanDayId": "f35pQRG1is/z7T9PuJ4fKg==",
        "AssessmentTypeId": 1,
        "Protocol": "Mazhar Regression Admin Tablet App QA",
        "CycleAndDay": "Cycle-1 (1 of 3) Day 14",
        "Nausea": 0,
        "Vomiting": 0,
        "Diarrhoea": 0,
        "Constipation": 0,
        "Fatigue": 0,
        "PeripheralNeuropathy": null,
        "SkinToxicity": 2,
        "SkinToxicityTypeID": 1,
        "SkinToxicityTypeName": "Rash acneiform",
        "ActionTakenID": "8",
        "ActionName": "Local assessment form completed1",
        "OralMucositis": 0,
        "PsychosocialAssessment": 0,
        "PerianalSkinAssessment": null,
        "ECOGScore": 0,
        "BARFScale": null,
        "InsertedBy": "Inzimam Kiyani",
        "InsertedAtDate": "2024-12-02T10:37:14.59",
        "InsertedAtTime": "07:56",
        "IsActive": true,
        "Notes": "",
        "IsImages": true,
        "UserID": "KUkpOpz6jLmeDBcgaqF6mg==",
        "IsDeleted": false,
        "TotalRecords": 6
    },
    {
        "PatientAssessmentId": "DZNTiYVG2SlN2DRpAc2lEw==",
        "TreatmentPlanDayId": "f35pQRG1is/z7T9PuJ4fKg==",
        "AssessmentTypeId": 1,
        "Protocol": "Mazhar Regression Admin Tablet App QA",
        "CycleAndDay": "Cycle-1 (1 of 3) Day 14",
        "Nausea": 1,
        "Vomiting": 1,
        "Diarrhoea": 1,
        "Constipation": 1,
        "Fatigue": 1,
        "PeripheralNeuropathy": 1,
        "SkinToxicity": null,
        "SkinToxicityTypeID": null,
        "SkinToxicityTypeName": null,
        "ActionTakenID": "3",
        "ActionName": "Prescription organised",
        "OralMucositis": 1,
        "PsychosocialAssessment": 0,
        "PerianalSkinAssessment": null,
        "ECOGScore": 1,
        "BARFScale": null,
        "InsertedBy": "Inzimam Kiyani",
        "InsertedAtDate": "2024-12-02T07:56:38.89",
        "InsertedAtTime": "07:56",
        "IsActive": true,
        "Notes": "",
        "IsImages": false,
        "UserID": "KUkpOpz6jLmeDBcgaqF6mg==",
        "IsDeleted": false,
        "TotalRecords": 6
    },
    {
        "PatientAssessmentId": "iwS5LPCsP8iHveClSm8BAQ==",
        "TreatmentPlanDayId": "f35pQRG1is/z7T9PuJ4fKg==",
        "AssessmentTypeId": 1,
        "Protocol": "Mazhar Regression Admin Tablet App QA",
        "CycleAndDay": "Cycle-1 (1 of 3) Day 14",
        "Nausea": null,
        "Vomiting": 4,
        "Diarrhoea": 4,
        "Constipation": 4,
        "Fatigue": null,
        "PeripheralNeuropathy": 4,
        "SkinToxicity": null,
        "SkinToxicityTypeID": null,
        "SkinToxicityTypeName": null,
        "ActionTakenID": "2",
        "ActionName": "Medical review requested",
        "OralMucositis": 4,
        "PsychosocialAssessment": 0,
        "PerianalSkinAssessment": null,
        "ECOGScore": 4,
        "BARFScale": null,
        "InsertedBy": "Inzimam Kiyani",
        "InsertedAtDate": "2024-12-02T07:55:37.83",
        "InsertedAtTime": "07:55",
        "IsActive": true,
        "Notes": "",
        "IsImages": false,
        "UserID": "KUkpOpz6jLmeDBcgaqF6mg==",
        "IsDeleted": false,
        "TotalRecords": 6
    },
    {
        "PatientAssessmentId": "ZfrpauLG3CWFZTmvonOmqA==",
        "TreatmentPlanDayId": "f35pQRG1is/z7T9PuJ4fKg==",
        "AssessmentTypeId": 1,
        "Protocol": "Mazhar Regression Admin Tablet App QA",
        "CycleAndDay": "Cycle-1 (1 of 3) Day 14",
        "Nausea": 3,
        "Vomiting": 3,
        "Diarrhoea": 3,
        "Constipation": 3,
        "Fatigue": 3,
        "PeripheralNeuropathy": 3,
        "SkinToxicity": null,
        "SkinToxicityTypeID": null,
        "SkinToxicityTypeName": null,
        "ActionTakenID": "5",
        "ActionName": "Other (specify in notes)",
        "OralMucositis": 3,
        "PsychosocialAssessment": 0,
        "PerianalSkinAssessment": null,
        "ECOGScore": 3,
        "BARFScale": null,
        "InsertedBy": "Inzimam Kiyani",
        "InsertedAtDate": "2024-12-02T07:55:18.303",
        "InsertedAtTime": "07:55",
        "IsActive": true,
        "Notes": "",
        "IsImages": false,
        "UserID": "KUkpOpz6jLmeDBcgaqF6mg==",
        "IsDeleted": false,
        "TotalRecords": 6
    },
    {
        "PatientAssessmentId": "dTA2jN5xkiZl0hOU6WT1yw==",
        "TreatmentPlanDayId": "f35pQRG1is/z7T9PuJ4fKg==",
        "AssessmentTypeId": 1,
        "Protocol": "Mazhar Regression Admin Tablet App QA",
        "CycleAndDay": "Cycle-1 (1 of 3) Day 14",
        "Nausea": 1,
        "Vomiting": 1,
        "Diarrhoea": 1,
        "Constipation": 1,
        "Fatigue": 2,
        "PeripheralNeuropathy": 1,
        "SkinToxicity": 2,
        "SkinToxicityTypeID": 2,
        "SkinToxicityTypeName": "Palmar-plantar erythrodysesthesia syndrome",
        "ActionTakenID": "2",
        "ActionName": "Medical review requested",
        "OralMucositis": 2,
        "PsychosocialAssessment": 0,
        "PerianalSkinAssessment": null,
        "ECOGScore": 1,
        "BARFScale": null,
        "InsertedBy": "Inzimam Kiyani",
        "InsertedAtDate": "2024-12-02T07:54:57.73",
        "InsertedAtTime": "07:54",
        "IsActive": true,
        "Notes": "",
        "IsImages": false,
        "UserID": "KUkpOpz6jLmeDBcgaqF6mg==",
        "IsDeleted": false,
        "TotalRecords": 6
    },
    {
        "PatientAssessmentId": "UrB22X72ofCHncS7h54GZw==",
        "TreatmentPlanDayId": "f35pQRG1is/z7T9PuJ4fKg==",
        "AssessmentTypeId": 1,
        "Protocol": "Mazhar Regression Admin Tablet App QA",
        "CycleAndDay": "Cycle-1 (1 of 3) Day 14",
        "Nausea": 1,
        "Vomiting": 1,
        "Diarrhoea": 2,
        "Constipation": 2,
        "Fatigue": 3,
        "PeripheralNeuropathy": 2,
        "SkinToxicity": null,
        "SkinToxicityTypeID": 1,
        "SkinToxicityTypeName": "Rash acneiform",
        "ActionTakenID": "1",
        "ActionName": "Referral made (specify in notes)",
        "OralMucositis": 2,
        "PsychosocialAssessment": 1,
        "PerianalSkinAssessment": null,
        "ECOGScore": 0,
        "BARFScale": null,
        "InsertedBy": "Inzimam Kiyani",
        "InsertedAtDate": "2024-12-02T07:46:18.573",
        "InsertedAtTime": "07:46",
        "IsActive": true,
        "Notes": "",
        "IsImages": false,
        "UserID": "KUkpOpz6jLmeDBcgaqF6mg==",
        "IsDeleted": false,
        "TotalRecords": 6
    }
]
 
 